var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fabric-modal-outer tw-fixed tw-top-0 tw-left-0 tw-pl-0 tw-transition-opacity tw-duration-150 ease-linear tw-overflow-x-hidden tw-overflow-y-auto show tw-w-full tw-h-full tw-z-modal",class:[
    (_vm.isHidden ? 'opacity-0' : 'opacity-100'),
    (_vm.isStatic ? 'modal-static' : 'modal-root'),
  ],on:{"click":_vm.onClickOut}},[_c('div',{staticClass:"tw-flex tw-relative tw-items-center tw-transition-transform tw-duration-500 tw-ease-out tw-m-2 smModal:tw-my-7 smModal:tw-mx-auto",class:[
      _vm.sizeStyle,
      _vm.dialogClass,
      _vm.overflowStyle,
      {
        'tw-min-h-modal': _vm.centered,
        'tw--translate-y-72': _vm.isHidden,
      },
    ],attrs:{"data-label":'modal-dialog modal-dialog-' + _vm.size}},[(!!_vm.isStatic)?_vm._t("default"):_vm._e()],2),_c('div',{staticClass:"tw-hidden tw-w-4/5 tw-max-w-none tw-min-w-[30%]"})])
}
var staticRenderFns = []

export { render, staticRenderFns }